import { useI18n } from 'vue-i18n'
export default class FootballStatus {
  static ERROR = 0;
  static NOT_START = 1;
  static FIRST_HALF = 2;
  static MIDFIELD = 3;
  static SECOND_HALF = 4;
  static OVERTIME = 5;
  static OVERTIME_1 = 6;
  static PENALTY_KICK = 7;
  static FINISH = 8;
  static PUT_OFF = 9;
  static INTERRUPT = 10;
  static WAIST_CUT = 11;
  static CANCELED = 12;
  static DETERMINED = 13;

  static getStatus(status) {
    const { t } = useI18n()
    switch (status) {
      case FootballStatus.ERROR:
        return t('match.matcherr');
      case FootballStatus.NOT_START:
        return t('match.nomatch');
      case FootballStatus.FIRST_HALF:
        return t("match.onlive");
      case FootballStatus.MIDFIELD:
        return t("match.onlive");
      case FootballStatus.SECOND_HALF:
        return t("match.onlive");
      case FootballStatus.OVERTIME:
        return t("match.matchjss");
      case FootballStatus.OVERTIME_1:
        return t("match.matchjss");
      case FootballStatus.PENALTY_KICK:
        return t("match.matchjss");
      case FootballStatus.FINISH:
        return t("match.matchwc");
      case FootballStatus.PUT_OFF:
        return t("match.matchtc");
      case FootballStatus.INTERRUPT:
        return t("match.matchzd");
      case FootballStatus.WAIST_CUT:
        return t("match.matchyz");
      case FootballStatus.CANCELED:
        return t('tips.cancel');
      case FootballStatus.DETERMINED:
        return t('match.matchdd');
    }
    return '';
  }
}
